import React, { lazy } from 'react';

import 'react-toastify/dist/ReactToastify.css';
import { Router, Switch, Route, Redirect } from 'react-router-dom';
import PageLoader from './components/PageLoader';
import SuspenseWithChunkError from './components/SuspenseWithChunkError';
import history from './routerHistory'
import 'bootstrap/dist/css/bootstrap.min.css';

// const Home = lazy(() => import('./screens/home/HomeView'))


const Home = lazy(async () => {
  await new Promise(resolve => setTimeout(resolve, 2000));
  return  import('./screens/home/HomeView');
});
function App() {
  return (
    <Router history={history}>
      <SuspenseWithChunkError fallback={<PageLoader />}>

        <Switch>
          <Route
            path="/" exact>
            <Home />
          </Route>
          <Redirect to={{ pathname: "/" }} />
        </Switch>
      </SuspenseWithChunkError>

    </Router>
  );
}

export default App;
